module.exports = __webpack_public_path__ + "img/LUB00143.a17b77d5.png";